import { render, staticRenderFns } from "./selectPlace.vue?vue&type=template&id=4f0678e2&"
import script from "./selectPlace.vue?vue&type=script&lang=js&"
export * from "./selectPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports